import type { UpdatesPort } from '../types';

/** Web: the service worker brings new versions (ui/components/UpdatePrompt.tsx). */
export function createWebUpdates(): UpdatesPort {
  return {
    confirm: () => undefined,
    check: () => Promise.resolve({ kind: 'none' }),
    apply: () => Promise.resolve(),
  };
}
